import React, {useState, useEffect} from 'react';
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
import axios from "axios";
import {Dropdown} from "primereact/dropdown";

import MachinecycleCalendarComponent from "./ScheduleitemMachinecycleCalendarComponent";

const ScheduleitemCalendarComponent = (props) => {

  const {t} = props;
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    axios.get(process.env.REACT_APP_API_HOST + "/api/v2/schedule-group", {
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
      .then(response => {
        setGroups(response.data.data.items);
        if(response.data.data.items[0] && response.data.data.items[0].id && response.data.data.items[0].type) {
          window.App.setState({
            selectedScheduleGroup:
              {
                id: response.data.data.items[0].id,
                type: response.data.data.items[0].type,
              }
          })
        }
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
      })
  }, [])

  return (
    <div className={"scheduleitem-calendar widget"}>
      {loading &&
        <ProgressBar mode="indeterminate" style={{height: '5px'}}></ProgressBar>
      }
      <div className={"p-grid p-d-none"}>
        <div className={"p-col-12 p-lg-6 p-col-align-center"}>

        </div>
        <div className={"p-col-12 p-lg-6 p-col-align-center p-text-right"}>
          <Dropdown options={groups}
                    optionLabel="name"
                    optionValue="id"
                    id={"groups"}
                    showClear
                    emptyMessage={t('no_dropdown_options')}
                    onChange={(e) => {
                      let _group = groups.filter(group => group.id === e.value);
                      let _type = ''
                      if(_group && _group[0]) {
                        _type = _group[0].type;
                      }
                      window.App.setState({
                        selectedScheduleGroup:
                          {
                            id: e.value,
                            type: _type,
                          }
                      })
                    }}
                    value={window.App.state.selectedScheduleGroup?.id}
          />
        </div>
      </div>
      {window.App.state.selectedScheduleGroup && window.App.state.selectedScheduleGroup.type && window.App.state.selectedScheduleGroup.type === 'MACHINE_CAPACITY' &&
        <>
        <MachinecycleCalendarComponent />
        </>
      }
    </div>
  )
}
export default withTranslation('common')(ScheduleitemCalendarComponent);
